module.exports = __webpack_public_path__ + "img/1.3d66eab0.png";